import { useMemo } from "react";
import { useRuntime } from "@/react/runtime/RuntimeContext";
import { IoService } from "../services/IoService";

/** IoService bound to the runtime's shared HttpPort (auth + tenant headers). */
export function useIoService(): IoService {
    const runtime = useRuntime();
    return useMemo(() => new IoService(runtime.http), [runtime]);
}
